import { Box, Button, Popover, TextField, Typography } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import DateTimePickerCustomTime from "components/DateTimePickerCustomTime";
import ReceiptPaper from "components/ReceiptPaper";
import TagBox from "components/TagBox";
import { jobOrderColNm } from "constants/jobOrderConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import React, { useCallback, useContext, useMemo, useState } from "react";

const shortDateProp = {
  inputFormat: "DD/MM HH:mm",
  mask: "__/__ __:__"
}

const JODataExtraComponent = ({ joData, setJOData, tagData, setTagData, compact }) => {

  const { msData } = useContext(GlobalStateContext)
  const [anchorEl, setAnchorEl] = useState(null);

  const datePickerJobOrderProp = useCallback((name, isRequire) => ({
    label: jobOrderColNm[name],
    inputFormat: "DD/MM/YYYY HH:mm",
    mask: "__/__/____ __:__",
    value: joData[name],
    onChange: (newValue) => { setJOData(oldState => ({ ...oldState, [name]: newValue && newValue.format("YYYY-MM-DD HH:mm:00.00") })) },
    renderInput: (params) => <TextField size="small"  {...params} required={isRequire} sx={{ width: compact ? "100%" : 150 }} />,
  }), [joData, setJOData, compact])


  const refJobOrderColNm = useMemo(() => {
    const result = { ...jobOrderColNm }
    const refColumnName = msData.serverData.RefColumnName?.job_order || {}
    for (const name in refColumnName) {
      result[name] = refColumnName[name]
    }
    return result
  }, [msData.serverData])


  const handleRcptButtonClick = useCallback((e) => {
    setAnchorEl(e.currentTarget);
  }, [])

  const dataProp = useCallback((name) => ({
    variant: "outlined",
    size: "small",
    name: name,
    label: refJobOrderColNm[name],
    value: joData[name],
    onChange: (e) => setJOData((oldData) => ({ ...oldData, [name]: e.target.value }))
  }), [joData, setJOData, refJobOrderColNm])

  const rcptPopover = (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={() => setAnchorEl(null)}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <ReceiptPaper rcptData={joData} />
    </Popover>
  )

  if (compact) {
    const fullRow = { gridColumn: "1 / -1" }
    return (
      <Box component="section">
        <Typography sx={{ fontWeight: 700, fontSize: 16, mb: 1.5 }}>ข้อมูลเพิ่มเติม</Typography>
        <Box sx={{
          display: "grid", gap: 1.5,
          gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(4, minmax(0, 1fr))" }
        }}>
          <DateTimePickerCustomTime {...datePickerJobOrderProp("TakeAptTm", false)} {...shortDateProp} />
          <DateTimePickerCustomTime {...datePickerJobOrderProp("RtnAptTm", false)} {...shortDateProp} />
          <TextField {...dataProp("Ref1")} fullWidth />
          <TextField {...dataProp("Ref2")} fullWidth />
          <DateTimePickerCustomTime {...datePickerJobOrderProp("FinDte", false)} {...shortDateProp} />
          <TagBox value={tagData} setValue={setTagData} tblAbbr="JO" sx={{ width: "100%", gridColumn: { xs: "1 / -1", sm: "span 3" } }} />
          <Button variant="outlined" sx={{ ...fullRow, minHeight: 44 }} onClick={handleRcptButtonClick}>
            ดูชื่อ-ที่อยู่ใบเสร็จ
          </Button>
        </Box>
        {rcptPopover}
      </Box>
    )
  }

  return (
    <BoxFC sx={{ gap: 1 }}>

      <Button size="small" variant="contained" sx={{ p: 0, width: 150 }} onClick={handleRcptButtonClick}>
        ชื่อ-ที่อยู่ใบเสร็จ</Button>
      {rcptPopover}
      <BoxFR sx={{ alignItems: "stretch" }}>
        <BoxFC sx={{ gap: 1 }}>

          <DateTimePickerCustomTime {...datePickerJobOrderProp("FinDte", false)} {...shortDateProp} />

          <TagBox value={tagData} setValue={setTagData} tblAbbr="JO" sx={{ width: 150 }} />
        </BoxFC>
        <BoxFC sx={{ gap: 1 }}>

          <DateTimePickerCustomTime {...datePickerJobOrderProp("TakeAptTm", false)} {...shortDateProp} />
          <DateTimePickerCustomTime {...datePickerJobOrderProp("RtnAptTm", false)} {...shortDateProp} />
          <TextField {...dataProp("Ref1")} sx={{ width: 150 }} />
          <TextField {...dataProp("Ref2")} sx={{ width: 150 }} />
        </BoxFC>
      </BoxFR>

    </BoxFC>
  )
}

export default React.memo(JODataExtraComponent);